import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth-service';
import { CommonService } from './common-service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public commonService: CommonService,
    public router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    if (urlToken) {
      sessionStorage.setItem('token', urlToken);
      sessionStorage.setItem('auth_token', urlToken);
      localStorage.setItem('token', urlToken);
      localStorage.setItem('auth_token', urlToken);

      const vendors = urlParams.get('vendors');
      let isCard = false;
      let currentActive = '';
      if (vendors) {
        sessionStorage.setItem('vendors', vendors);
        localStorage.setItem('vendors', vendors);
        try {
          const vObj = JSON.parse(vendors);
          const activeBanking = urlParams.get('activeBankingInstitution') || vObj?.banking?.[0]?.id || '';
          const activeCards = urlParams.get('activeCardsInstitution') || vObj?.cards?.[0]?.id || '';
          const type = urlParams.get('type') || urlParams.get('service');
          isCard = type === 'card' || Boolean(vendors && vendors.includes('"cards"') && !vendors.includes('"banking"'));
          currentActive = urlParams.get('currentActiveInstitution') || (isCard ? activeCards : activeBanking);
          if (activeBanking) {
            sessionStorage.setItem('activeBankingInstitution', activeBanking);
            localStorage.setItem('activeBankingInstitution', activeBanking);
          } else {
            sessionStorage.removeItem('activeBankingInstitution');
            localStorage.removeItem('activeBankingInstitution');
          }
          if (activeCards) {
            sessionStorage.setItem('activeCardsInstitution', activeCards);
            localStorage.setItem('activeCardsInstitution', activeCards);
          } else {
            sessionStorage.removeItem('activeCardsInstitution');
            localStorage.removeItem('activeCardsInstitution');
          }
          if (currentActive) {
            sessionStorage.setItem('currentActiveInstitution', currentActive);
            localStorage.setItem('currentActiveInstitution', currentActive);
            this.commonService.vendorId.next(currentActive);
          }
        } catch (e) {}
      } else {
        const type = urlParams.get('type') || urlParams.get('service');
        isCard = (type === 'card');
      }

      const userDetails = urlParams.get('userDetails');
      if (userDetails) {
        sessionStorage.setItem('userDetails', userDetails);
        localStorage.setItem('userDetails', userDetails);
      }
      const userType = urlParams.get('userType') || 'Admin';
      sessionStorage.setItem('userType', userType);
      localStorage.setItem('userType', userType);

      this.commonService.currentActiveModule.next(isCard ? 'Cards' : 'Banking');
      sessionStorage.setItem('currentActiveModule', isCard ? 'Cards' : 'Banking');

      const targetRoute = isCard ? '/home/eCards/dashboard' : '/home/eBank/dashboard';
      window.history.replaceState({}, document.title, targetRoute);
      return this.router.parseUrl(targetRoute);
    }

    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (token && token !== 'null' && token !== 'undefined' && token !== '') {
      if (!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', token);
      }
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
